import { t } from 'i18next'

import { Country } from 'app/types/park/site'
import { Day } from 'app/types/shared/day'

/** Search params used on the site page. */
export const searchParametersSite = {
    ADDRESS: 'address',
    CITY: 'city',
    CLIENT: 'client',
    COUNTRY: 'country',
    MANAGER: 'manager',
    NAME: 'name',
    POSTAL_CODE: 'postal_code',
}

/** Search params used in the site API. */
export const searchParametersSiteApi = {
    ADDRESS: 'address__icontains',
    CITY: 'city__icontains',
    CLIENT: 'customer_name__id__in',
    COUNTRY: 'country__in',
    HAS_ORDER: 'has_order',
    MANAGERS: 'customer_name__client__id__in',
    NAME: 'name__icontains',
    POSTAL_CODE: 'postal_code__icontains',
}

/** Get the translation of a country. */
export const countryTranslated: () => Record<Country, string> = () => ({
    BELGIUM: t('belgium'),
    FRANCE: t('france'),
    GERMANY: t('germany'),
    ITALY: t('italy'),
    LUXEMBOURG: t('luxembourg'),
    NETHERLANDS: t('netherlands'),
    PORTUGAL: t('portugal'),
    SPAIN: t('spain'),
    SWITZERLAND: t('switzerland'),
    UNITED_KINGDOM: t('unitedKingdom'),
    UNITED_STATES_OF_AMERICA: t('unitedStateOfAmerica'),
})

/** Get the translation of a week day. */
export const weekDayTranslated: () => Record<Day, string> = () => ({
    MONDAY: t('monday'),
    TUESDAY: t('tuesday'),
    WEDNESDAY: t('wednesday'),
    THURSDAY: t('thursday'),
    FRIDAY: t('friday'),
    SATURDAY: t('saturday'),
    SUNDAY: t('sunday'),
})

/** Get the code of a country. */
export const countryCode: Record<Country, string> = {
    BELGIUM: 'be',
    FRANCE: 'fr',
    GERMANY: 'de',
    ITALY: 'it',
    LUXEMBOURG: 'lu',
    NETHERLANDS: 'nl',
    PORTUGAL: 'pt',
    SPAIN: 'es',
    SWITZERLAND: 'ch',
    UNITED_KINGDOM: 'gb',
    UNITED_STATES_OF_AMERICA: 'us',
}

/** Get the locale of a country.*/
export const countryLocale: Record<Country, string> = {
    BELGIUM: 'fr-BE',
    FRANCE: 'fr',
    GERMANY: 'de',
    ITALY: 'it',
    LUXEMBOURG: 'lu',
    NETHERLANDS: 'nl',
    PORTUGAL: 'pt',
    SPAIN: 'es',
    SWITZERLAND: 'ch',
    UNITED_KINGDOM: 'gb',
    UNITED_STATES_OF_AMERICA: 'us',
}

/** Get the code of a week day. */
export const weekdayCode: Record<Day, string> = {
    MONDAY: 'mo',
    TUESDAY: 'tu',
    WEDNESDAY: 'we',
    THURSDAY: 'th',
    FRIDAY: 'fr',
    SATURDAY: 'sa',
    SUNDAY: 'su',
}
